import { Modal } from 'antd';
import ReactDOM from "react-dom";
import ShareComponent from './ShareComponent';

//mismo vidrio oscuro que los controles de la vista 360 (estilos en controles.css)
export const ModalShare = ({showModal, setShowModal, titulo, url}) => {
    const handleCancel = () => {
      setShowModal(false)
    };
    return ReactDOM.createPortal(
      <Modal
        title="Compartí esta experiencia"
        open={showModal}
        onCancel={handleCancel}
        footer={null}
        width={380}
        centered
        rootClassName="p360-share-modal"
        closeIcon={
          <svg className="p360-ic" width="18" height="18" viewBox="0 0 24 24" aria-label="Cerrar">
            <path d="M6 6l12 12M18 6L6 18" />
          </svg>
        }
      >
        <ShareComponent url={url} title={titulo} />
      </Modal>,
      document.getElementById('modal')
    );
}
